import { em } from 'polished'
import styled, { css } from 'styled-components'

import DynamicImage from 'components/DynamicImage'

export const DynamicImageStyled = styled(DynamicImage)`
  display: none;

  ${p => p.theme.mq.upMd} {
    display: block;
    left: -${em(30)};
    top: -${em(4)};
    position: absolute;
  }

  ${p => p.theme.mq.upLg} {
    height: ${em(770)};
    left: auto;
  }
`

export const ImageWrapper = styled.div`
  position: absolute;
  right: ${em(15)};
  height: 75%;
  top ${em(40)};

  ${p =>
    p.isUS &&
    css`
      height: 86%;
      right: ${em(0)};
      top: ${em(0)};

      ${p => p.theme.mq.downMd} {
        height: 100%;
        left: ${em(10)};
      }
    `}

  ${p => p.theme.mq.upMd} {
    height: 57%;
    right: ${em(15)};
    top: ${em(70)};

    ${p =>
      p.isUS &&
      css`
        height: 61%;
        right: 0;
        top: ${em(57)};
      `}
  }

   ${p => p.theme.mq.upLg} {
     height: 72%;
     right: ${em(95)};
     top: ${em(110)};

     ${p =>
       p.isUS &&
       css`
         height: 85%;
         top: ${em(74)};
         right: ${em(67)};
       `}
   }
`

export const Wrapper = styled.div`
  position: relative;
  height: ${em(440)};
  width: ${em(280)};
  border: 12px solid #000000;
  border-radius: 20px;
  background: #ffffff;
  box-shadow: 10px 20px 24px rgba(0, 0, 0, 0.15),
    4px 4px 10px rgba(0, 0, 0, 0.4);
  margin: ${em(100)} auto ${em(30)};

  ${p => p.theme.mq.upMd} {
    position: absolute;
    right: 0;
    top: 15%;
    margin-bottom: 0;
    height: ${em(600)};
    width: ${em(450)};
    border: none;
    border-radius: 0;
    box-shadow: none;
    background: none;
  }

  ${p => p.theme.mq.upLg} {
    top: auto;
    bottom: 0;
    margin-top: 0;
    width: ${em(775)};
    height: ${em(515)};
  }
`

export const IconWrapper = styled.div`
  height: ${em(90)};
  width: 100%;
  left: ${em(50)};
  top: -${em(102)};
  position: absolute;

  ${p => p.theme.mq.upMd} {
    width: ${em(220)};
    height: ${em(90)};
    left: 50%;
    top: -${em(51)};
  }

  ${p => p.theme.mq.upLg} {
    height: ${em(123)};
    top: -${em(71)};
  }
`

export const Center = styled.div`
  text-align: center;
`
